import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../../apiClient'
import {
  trainingApiPrefix,
  trainingQueryKey,
  type TrainingApiOptions,
} from '../../training-modules/trainingModuleApi'

export type PlanCapacityMS = {
  notStarted?: TrainingModuleMS[]
  inProgress?: TrainingModuleMS[]
  certified?: TrainingModuleMS[]
}

export type TrainingModuleMS = {
  missionSpecialist: {
    userName?: string
    userId?: string
    userEmail?: string
    avatarUrl?: string | null
    eligible: boolean
    trainingStats?: {
      programId: string
      state: 'not_started' | 'in_progress' | 'certified'
      trainingTtc?: number | null
      avgTtc?: number | null
      avgAccuracy?: number | null
      attempts?: number
      firstSessionDate?: string | null
      firstDateInvited?: string | null
      lastRemindedAt?: string | null
      lastSessionDate?: string | null
      progress: number | null
    }
  }
}

export const PROGRAM_PLAN_CAPACITY_MS_QUERY_KEY = 'program-plan-capacity-ms'

export function useGetList(programId?: string, { target = 'legacy' }: TrainingApiOptions = {}) {
  return useQuery({
    queryKey: trainingQueryKey(PROGRAM_PLAN_CAPACITY_MS_QUERY_KEY, programId, target),
    queryFn: async () => {
      if (!programId) throw new Error('Training program is not available')
      const response = await apiClient.get<PlanCapacityMS>(
        `${trainingApiPrefix(target)}/programs/${programId}/training-modules`
      )
      return response.data
    },
    enabled: Boolean(programId) && (target === 'legacy' || target === 'modern'),
    refetchOnWindowFocus: false,
  })
}
